import React from 'react';
import {
  Box,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

/**
 * Výber rozsahu kontroly.
 *
 * GDPR je implicitné a nedá sa vypnúť. NIS2 (kybernetické a technické údaje)
 * a VYHRADENÉ (utajované skutočnosti) sú voliteľné — kontrolujú sa len keď si
 * ich používateľ zapne. Nezvolené rodiny sa vôbec nedetegujú.
 */
const ValidationScopeSelector = ({ scope, onChange, disabled = false }) => {
  const value = ['gdpr', ...(scope?.nis2 ? ['nis2'] : []), ...(scope?.classified ? ['classified'] : [])];

  const handleChange = (_event, next) => {
    const selected = Array.isArray(next) ? next : [];
    onChange({
      nis2: selected.includes('nis2'),
      classified: selected.includes('classified'),
    });
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        Rozsah kontroly
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        Osobné údaje (GDPR) sa kontrolujú vždy. Ďalšie okruhy si zapnite podľa potreby.
      </Typography>

      <ToggleButtonGroup
        value={value}
        onChange={handleChange}
        aria-label="Rozsah kontroly"
        size="small"
        sx={{
          flexWrap: 'wrap',
          gap: 1,
          '& .MuiToggleButtonGroup-grouped': {
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            fontWeight: 600,
            px: 2,
          },
        }}
      >
        <Tooltip title="Osobné údaje podľa GDPR — vždy zapnuté">
          <ToggleButton value="gdpr" disabled aria-label="GDPR" selected>
            <GavelOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
            GDPR
          </ToggleButton>
        </Tooltip>

        <Tooltip title="Kybernetické a technické údaje (sieťové identifikátory, prístupové údaje, cloud/infraštruktúra)">
          <ToggleButton value="nis2" disabled={disabled} aria-label="NIS2">
            <SecurityOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
            NIS2
          </ToggleButton>
        </Tooltip>

        <Tooltip title="Utajované skutočnosti stupňa VYHRADENÉ">
          <ToggleButton value="classified" disabled={disabled} aria-label="VYHRADENÉ">
            <LockOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
            VYHRADENÉ
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>

      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Kontroluje sa: GDPR
          {scope?.nis2 ? ' + NIS2' : ''}
          {scope?.classified ? ' + VYHRADENÉ' : ''}
        </Typography>
      </Stack>
    </Box>
  );
};

export default ValidationScopeSelector;
